//@ts-nocheck
import React, { useState, useEffect } from 'react';
import {
  Modal,
  Select,
  Input,
  DoneRoundIcon,
  CloseBigIcon,
  DatePicker,
  Upload,
  Button,
  notification,
} from '@gamesb42/ui-kit';
import { Form, UploadFile } from 'antd';
import moment from 'moment';

import baseRequest from 'queries/baseRequest';
import { getCompanies } from 'api/company';
import CompanySelect from 'components/CompanySelect';
import Flex from 'components/Flex';
import { convertFileToBase64 } from 'helpers/file';
import { useParams } from 'react-router-dom';
import { deleteDocument, restoreDocument } from 'api/docs';

import s from './styles.module.scss';

export default function EditDocModal({ onClose, getData, docTypes, activeRecord }) {
  const [form] = Form.useForm();
  const [docType, setDocType] = useState('');
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [fileContent, setFileContent] = useState<string | null>(null);
  const { companyId } = useParams();
  const [okDisabled, setOkDisabled] = useState(true);

  const beforeUpload = (file: any) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const content = e.target?.result as string;
      setFileContent(content);
      setFileList([...fileList, file]);
      form
        .validateFields()
        .then(() => {
          setOkDisabled(false);
        })
        .catch(() => {
          setOkDisabled(true);
        });
    };
    reader.readAsText(file);
    return false;
  };

  const handleEdit = async () => {
    try {
      const validateResult = await form.validateFields();
    } catch (e) {
      console.log(e);
      return;
    }

    const { documentDate, documentName, documentNo, documentType, comment } = form.getFieldsValue();
    let reqBody = {
      document_type_id: documentType,
      document_name: documentName,
      document_number: documentNo,
      document_date: documentDate.format('YYYY-MM-DD'),
      comment,
    };

    if (activeRecord?.parent_document?.document_id)
      reqBody = { ...reqBody, parent_document_id: activeRecord?.parent_document?.document_id };

    if (fileList?.length > 0 && fileContent) {
      const fileRaw = await convertFileToBase64(fileList[fileList.length - 1]);
      const fileSplit = fileRaw?.split(',');

      reqBody = { ...reqBody, document_content: fileSplit[1] };
    }

    baseRequest({
      path: `${process.env.REACT_APP_BASE_URL}/documents/${activeRecord.document_id}`,
      options: {
        method: 'PUT',
        body: JSON.stringify(reqBody),
      },
    })
      .then(() => getData())
      .finally(() => {
        onClose();
      });
  };

  useEffect(() => {
    setFileList([
      {
        uid: 'rc-upload-1746390076143-3',
        lastModified: 1746033127091,
        lastModifiedDate: '2025-04-30T17:12:07.091Z',
        name: activeRecord.document_name,
        size: 178932,
        type: 'application/pdf',
        percent: 0,
        originFileObj: {
          uid: 'rc-upload-1746390076143-3',
        },
      },
    ]);
    form.setFieldsValue({
      documentType: activeRecord.document_type,
      documentName: activeRecord.document_name,
      documentNo: activeRecord.document_number,
      documentDate: moment(activeRecord.document_date),
      comment: activeRecord.comment,
    });
  }, []);

  return (
    <Modal
      open
      title="Upload new document"
      width="838px"
      onCancel={onClose}
      footer={
        <Flex justify="space-between">
          <Button
            style={{ background: '#EC3E72', color: '#fff', border: 'none' }}
            onClick={() =>
              Modal.warning({
                title: 'Delete file',
                okButtonProps: {
                  style: { background: '#EC3E72', border: 'none' },
                },
                okText: 'Delete',
                content: `Are you shure you want to delete the file «${activeRecord.document_name}»?`,
                onOk: () =>
                  deleteDocument(activeRecord.document_id)
                    .then(() => {
                      onClose();
                      notification.warning({
                        theme: 'dark',
                        message: (
                          <Flex gap="10px" direction="column">
                            <div>{`The document «${activeRecord.document_name}» was deleted`}</div>
                            <Button
                              style={{ alignSelf: 'flex-end' }}
                              onClick={() => restoreDocument(activeRecord.document_id).finally(() => getData())}
                            >
                              Restore
                            </Button>
                          </Flex>
                        ),
                        placement: 'bottomLeft',
                      });
                    })
                    .finally(() => {
                      getData();
                    }),
                onCancel: () => {},
              })
            }
          >
            Delete
          </Button>
          <Button type="primary" onClick={handleEdit}>
            Save changes
          </Button>
        </Flex>
      }
    >
      <Form
        form={form}
        style={{ display: 'flex', flexDirection: 'column' }}
        onChange={async (e) => {
          try {
            await form.validateFields();
            setOkDisabled(false);
          } catch (e) {
            if (e?.errorFields?.length === 0) {
              setOkDisabled(false);
            } else {
              setOkDisabled(true);
            }
          }
        }}
      >
        <Form.Item name="documentType" rules={[{ required: true }]}>
          <Select label="Document type" size="large" options={docTypes} allowClear />
        </Form.Item>
        <Form.Item name="documentName" rules={[{ required: true }]}>
          <Input size="large" label="Document name" />
        </Form.Item>

        <Flex gap="32px">
          <Form.Item name="documentNo" rules={[{ required: true }]} style={{ width: '100%' }}>
            <Input size="large" label="Document No." />
          </Form.Item>
          <Form.Item name="documentDate" rules={[{ required: true }]} style={{ width: '100%' }}>
            <DatePicker size="large" label="Document date" />
          </Form.Item>
        </Flex>

        <Form.Item
          name="documentFile"
          rules={[
            (formInstance) => ({
              message: "'documentFile' is required",
              validator(rule, value) {
                if (value?.file.status === 'removed' || fileList?.length === 0) {
                  return Promise.reject(new Error());
                }

                return Promise.resolve();
              },
            }),
          ]}
        >
          <Upload
            fileList={fileList}
            beforeUpload={beforeUpload}
            maxCount={1}
            onRemove={() => {
              form.setFieldsValue({ documentFile: undefined, error: "'documentFile' is required" });
              setFileList([]);
              setFileContent(null);
              setOkDisabled(true);
            }}
          />
        </Form.Item>

        <Form.Item name="comment" style={{ width: '100%' }}>
          <Input.TextArea size="large" label="Comment" showCount={false} maxLength={100} />
        </Form.Item>
      </Form>
    </Modal>
  );
}
